module.exports = __webpack_public_path__ + "img/podbean-symbol-black.c54165e6.png";